<div class="example-table-container">

    <mat-table #table [dataSource]="dataSource" class="mat-elevation-z8 tbl-header" matSort>

        <!-- ID Column -->
        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.dependantId}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="dependant">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Dependant</mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.dependant}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="firstName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>First Name</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.firstName}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.lastName}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Gender">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Sex</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.sex}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="dob">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Date of Birth</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.dob  }}</mat-cell>
        </ng-container>

        <!-- actions -->
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef>
                <button mat-icon-button color="primary" (click)="addNew()">
                    <mat-icon aria-label="Example icon-button with a heart icon">add</mat-icon>
                </button>
            </mat-header-cell>

            <mat-cell *matCellDef="let row; let i=index;">
                <!-- <button mat-icon-button color="accent"
                (click)="startEdit(i, row.id, row.title, row.state, row.url, row.created_at)">
                <mat-icon aria-label="Edit">edit</mat-icon>
            </button> -->

                <button mat-icon-button color="accent"
                    (click)="deleteItem(i, row.dependant, row.firstName, row.lastName)">
                    <mat-icon aria-label="Delete">delete</mat-icon>
                </button>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

</div>